import disposableList from './disposable_domains.json';

const DISPOSABLE_SET = new Set(disposableList.map(d => d.toLowerCase()));

export function domainAusEmail(email) {
  if (!email || typeof email !== 'string' || !email.includes('@')) return null;
  const parts = email.trim().toLowerCase().split('@');
  if (parts.length !== 2 || !parts[0] || !parts[1]) return null;
  return parts[1];
}

export function istWegwerfEmail(email) {
  const domain = domainAusEmail(email);
  if (!domain) return false;
  return DISPOSABLE_SET.has(domain);
}
